import { render } from "./InfoLayer.vue?vue&type=template&id=79840fb7&scoped=true"
import script from "./InfoLayer.vue?vue&type=script&lang=js"
export * from "./InfoLayer.vue?vue&type=script&lang=js"

import "./InfoLayer.vue?vue&type=style&index=0&id=79840fb7&scoped=true&lang=css"

import exportComponent from "/tmp/build_642e477e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79840fb7"]])

export default __exports__